import { toLocaleFormat } from '../../../helpers/date-formatter';

export default {
  name : 'StatusCard',
  props: {
    statusLabel: {
      type: String,
      required: true,
    },
    status: {
      type: String,
      required: true,
    },
    endDate: {
      type: String,
      required: false,
      default: null
    },
    endDateLabel: {
      type: String,
      required: true,
    },
    lang: {
      type: String,
      default: 'en',
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    endDateFormat() {
      return toLocaleFormat(this.endDate, this.lang);
    },
    statusLogoClass() {
      return this.status ? 'status-card__logo--'+this.status.toLowerCase().trim() : 'status-card__logo--classic';
    }
  }
}
